
document.addEventListener("DOMContentLoaded", function() {
  const searchInput = document.querySelector('.js--search_input');
  const searchCategoryLinks = document.querySelectorAll('.js--search__menu_dropdown_item');
  const searchPageCategory = document.querySelector('.js--search_page_category');
  const $searchResult = document.querySelector('.js--search__result');
  const $searchResultBtn = document.querySelector('.js--search_result_btn');
  const $searchFormClose = document.querySelector('.js--search__form_close');
  const $searchFormButton = document.querySelector('.search__form_submit');
  const $searchMobileTrigger = document.querySelectorAll('.js--header__main_search_mobile');
  const $searchMobileContainer = document.querySelector('.js--search_container');
  const $body = document.body;
  const $root = document.getElementsByTagName( 'html' )[0];


  if ($searchMobileContainer) {
    const formElement = document.querySelector('.js--search__form');
    const searchSymbolTrigger = Number(formElement.getAttribute('data-trigger-search-symbols'));
    const formDefaultAction = formElement.action;
    let searchData = {
      category: '0',
      qry: '',
    };
    $searchMobileTrigger.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        if ($searchMobileContainer.classList.contains('isOpen')) {
          $searchMobileContainer.classList.remove('isOpen');
          $body.classList.remove('searchIsOpen');
          $root.classList.remove('searchIsOpen');
        } else {
          $searchMobileContainer.classList.add('isOpen');
          $body.classList.add('searchIsOpen');
          $root.classList.add('searchIsOpen');
          searchInput.focus();
        }
      })
    });
    $searchFormClose.addEventListener('click', (e) => {
      e.stopPropagation();
      searchInput.value = '';
      $searchFormButton.disabled = true;
      $searchResult.classList.remove('show');
      if ($searchMobileContainer.classList.contains('isOpen')) {
        $searchMobileContainer.classList.remove('isOpen');
        $body.classList.remove('searchIsOpen');
        $root.classList.remove('searchIsOpen');
      } else if (searchData.qry.length > 0) {
        searchInput.value = '';
        searchData.qry = '';
      }
      $searchFormClose.style.visibility = 'hidden';
    });
    searchInput.addEventListener('input', (event) => {
      const inputValue = event.target.value.trim();
      if (inputValue.length >= searchSymbolTrigger) {
        searchData.qry = inputValue;
        if (searchData.category && formElement.getAttribute('data-alias') !== 'pravo') {
          searchRequest(searchData);
          $searchResult.classList.add('show');
          $searchFormButton.disabled = false;
        } else {
          $searchResult.classList.remove('show');
        }

      } else {
        $searchResult.classList.remove('show');
      }
      if (event.target.value === '') {
        $searchFormClose.style.visibility = 'hidden';
      } else {
        $searchFormClose.style.visibility = 'visible';

      }
    });
    // searchInput.addEventListener('blur', function() {
    //   $searchResult.classList.remove('show');
    // });
    document.addEventListener('click', function (event) {
      if ($searchResult.classList.contains('show') && !$searchResult.contains(event.target) && !searchInput.contains(event.target)) {
        $searchResult.classList.remove('show');
      }
    });
    searchInput.addEventListener('focus', function () {
      if (searchData.qry.length >= searchSymbolTrigger) {
        if (searchData.category && searchData.category !== '0') {
          $searchResult.classList.add('show');
        } else {
          $searchResult.classList.remove('show');
        }
      }
    });
    // Обработчик события на выбор категории
    searchCategoryLinks.forEach(function (link) {

      link.addEventListener('click', function (event) {
        searchCategoryLinks.forEach(function (item) {
          item.classList.remove('active');
        });
        event.preventDefault();
        const category = this.getAttribute('data-value');
        const categoryAlias = this.getAttribute('data-alias');
        const pravoAlias = formElement.getAttribute('data-pravo');
        const categoryName = this.textContent;
        this.classList.add('active');
        searchData.category = category;
        if (categoryAlias === 'pravo') {
          if (pravoAlias) {
            formElement.action = `${pravoAlias}`;
          } else {
            formElement.action = `${formDefaultAction}`;
          }
        } else {
          formElement.action = `${formDefaultAction}/${categoryAlias}`;
        }
        formElement.setAttribute('data-alias', categoryAlias);
        document.querySelector('.search__form_category').textContent = categoryName;
        console.log(searchPageCategory);
        if (searchPageCategory) {
          searchPageCategory.textContent = categoryName;
        }
        if (searchData.qry !== '' && searchData.category !== '0' && formElement.getAttribute('data-alias') !== 'pravo') {
          searchRequest(searchData)
        }
      });
    });
    if (searchPageCategory) {
      console.log(searchPageCategory);
      searchPageCategory.textContent = document.querySelector('.search__form_category').textContent;
    }


    function searchRequest(query) {
      fetch(formElement.getAttribute('data-url-hint'), {
        method: 'POST',
        body: JSON.stringify(query),
        headers: {
          'Content-Type': 'application/json'
        }
      })
          .then(response => {

            if (!response.ok) {
              return response.text().then(text => {
                throw new Error(`Error ${response.status}: ${text}`);
              });
            }
            return response.json();
          })
          .then(data => {
            $searchResult.innerHTML = data;
          })
          .catch(error => {
            console.error('Error:', error);
          });
    }

    document.addEventListener('click', (event) => {
      if (event.target.closest('.js--search_result_btn')) {
        $searchFormButton.click();
      }
    });
    document.addEventListener('click', (event) => {
      if (event.target.closest('.js--search_hint')) {
        const hintText = document.querySelector('.js--search_hint').textContent;
        searchInput.value = hintText;
        $searchFormButton.click();
      }
    });
  }
});
